<template>
  <div>
    <div class="card">
      <div class="card-header">
        <strong>Create News Notes</strong>
      </div>

      <div class="card-body form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <label for="news-title" class="col-md-2">Title</label>
                <div class="col-md-10">
                  <input
                    id="news-title"
                    v-model="entity.title"
                    type="text"
                    placeholder="Enter Title"
                    class="form-control"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label for="news-body" class="col-md-2">Body</label>
                <div class="col-md-10">
                  <ckeditor id="branch-news-body" v-model="entity.body" />
                </div>
              </div>

              <div class="form-group row">
                <label for="bio" class="col-md-2">Cover</label>
                <div class="col-md-10">
                  <image-uploader
                    @changeFile="$_coverChange"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-12">
                  <div class="form-group row">
                    <label for="body" class="col-md-2 form-control-label">Files</label>
                    <div class="col-md-10">
                      <dropzone
                        v-if="dropzoneOptions"
                        id="files-uploader"
                        ref="dropzone"
                        :options="dropzoneOptions"
                        :destroy-dropzone="false"
                        @vdropzone-file-added="fileUploadedSuccess"
                        @vdropzone-removed-file="fileRemoved"
                      />
                      <div v-else>Dropzone can't work without upload url.</div>
                      <!-- Select File Button -->
                      <div class="mt-3">
                        <button class="btn btn-success" @click.prevent="$refs.dropzone.dropzone.element.click()">
                          Select File
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="news-publish" class="col-md-2">Publish Date</label>
                <div class="col-md-10">
                  <datepicker ref="datePckr" v-model="entity.publish_date" format="yyyy-MM-dd" />
                </div>
              </div>

              <div class="form-group row">
                <label for="news-unpublish" class="col-md-2">Unpublish Date</label>
                <div class="col-md-10">
                  <datepicker v-model="entity.unpublish_date" format="yyyy-MM-dd" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-5">
      <button class="btn btn-success" @click="save">
        Save
        <span class="btn-loader" style="display: none;" />
      </button>

      <div class="saving-alerts" style="margin-top: 20px;">
        <div class="alert alert-success" style="display: none;">
          News modified successfully!
        </div>
        <div class="alert alert-danger" style="display: none;">
          {{ saveErrorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import Datepicker from '@/global/components/Datepicker';

import {
  uploadStatus,
} from '@/helpers/constants';

// Mixins
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';
import CreatePageMixin from '@/mixins/CreatePageMixin';
import config from '../../../../config';

const {
  SUCCESS,
} = uploadStatus;

export default {
  name: 'NewNewsNotes',

  components: {
    dropzone: Dropzone,
    datepicker: Datepicker,
  },

  mixins: [DefaultOptionsRequests, CommonPageMixin, CreatePageMixin],


  data() {
    return {
      entity: {
        title: '',
        body: '',
        publish_date: new Date().toISOString().slice(0, 10),
        unpublish_date: '',
        cover: null,
      },
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048,
      },

      files: [],
      uploadedFiles: [],
      toDeleteFiles: [],

      itemId: null,
    };
  },

  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'media',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}news-notes/${this.$route.params.id}/file`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFiles() {
      const getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'news-notes');
    },
  },

  watch: {
    uploadingFiles: {
      handler(val) {
        this.uploadedFiles = val.filter(file => file.status === SUCCESS).map(file => file.file);
        const {
          dropzone,
        } = this.$refs;
        if (dropzone) {
          this.uploadedFiles.forEach(file => dropzone.removeFile(file));
          this.uploadedFiles.forEach((file) => {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src',
              'static/img/file-thumb.jpg');
          });
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.getSource();
  },

  methods: {

    getSource() {},

    fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved(file) {
      const fileIndex = _.findIndex(this.entity.images, item => item.file_name === file.name && item.size === file
        .size);
      if (fileIndex === -1) return;
      const fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },

    saveRequest() {
      const postFormData = new FormData();

      postFormData.append('title', this.entity.title);
      postFormData.append('branch_id', this.$route.params.id);

      postFormData.append('body', this.entity.body);
      postFormData.append('publish_date', this.entity.publish_date);
      postFormData.append('unpublish_date', this.entity.unpublish_date);

      return this.$apiHttp.post(`${this.$config.app_api.prefix}news-notes`,
        postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      const files = this.files.filter(file => !file.manuallyAdded);
      const {
        prefix,
        host,
      } = this.$config.app_api;
      const {
        acceptedFiles,
      } = this.dropzoneOptions;
      const vm = this;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));

      const dispatchStartUpload = (contentType, entityId) => {
        if (files && files.length > 0) {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId,
            files: [...files],
            token,
            acceptedFiles,
            contentType,
          });
          vm.files = [];
        }
      };

      this.saveRequest()
        .then((response) => {
          this.itemId = response.data.id;
          $('.btn-success .btn-loader').hide();
          this.$store.commit('notifications/setSuccessNotification', 'Success!');
          dispatchStartUpload(response.data.content_type, response.data.id);
          if (this.entity.cover) {
            this.saveCoverRequest(response.data.id);
          }
        })
        .then(() => {
          this.$emit('changeModeOnCreate');
        })
        .catch((error) => {
          this.$_errorSave(error);
          console.log(error.response.data.errors);
        });
    },
    saveCoverRequest(entityId) {
      const postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      this.$apiHttp.post(`${this.$config.app_api.prefix}news-notes/${entityId}/cover`, postFormData);
    },
    $_coverChange(file) {
      this.entity.cover = file;
    },
  },
};

</script>



// WEBPACK FOOTER //
// New.vue?e05944f0